module.exports = __webpack_public_path__ + "static/img/johnroxburgh_circle150.1404ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experts/johnroxburgh_circle150.png
// module id = xNFq
// module chunks = 0